import { render, staticRenderFns } from "./orderApr.vue?vue&type=template&id=e82b3e88&scoped=true&"
import script from "./orderApr.vue?vue&type=script&lang=js&"
export * from "./orderApr.vue?vue&type=script&lang=js&"
import style0 from "./orderApr.vue?vue&type=style&index=0&id=e82b3e88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82b3e88",
  null
  
)

export default component.exports